export default __webpack_public_path__ + "static/media/brazil-svgrepo-com.68c017bf.svg";